<li class="hover:bg-gray-50 px-4 py-4 sm:px-6" (click)="showProviderEvent.emit(treatmentProvider)">
  <div class="flex items-center space-x-4">
    @if (treatmentProvider.type == TreatmentType._211Resources) {
    <img style="height: 50px;" src="assets/New 211 logo.jpg" alt="">
    }
    <div class="flex-1 min-w-0">

      <p class="text-sm font-medium text-gray-900 truncate">
        {{treatmentProvider?.commonName || ""}}
      </p>
      <p class="text-sm text-gray-500 truncate">
        {{CityState || ""}}
      </p>
      <p>
        {{treatmentProvider?.phone || ""}}
      </p>
    </div>

  </div>

</li>
